// src/App.jsx
import { Toaster } from "react-hot-toast";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import AuthScreen from "./components/auth/AuthScreen";
import AdminDashboard from "./components/admin/AdminDashboard";
import CaptainDashboard from "./components/captain/CaptainDashboard";
import ClientDashboard from "./components/client/ClientDashboard";
import { LoadingScreen } from "./components/ui";

function Router() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen text="جاري تحميل رايدو..." />;
  if (!user) return <AuthScreen />;
  if (user.role === "admin") return <AdminDashboard />;
  if (user.role === "captain") return <CaptainDashboard />;
  if (user.role === "client") return <ClientDashboard />;
  return <LoadingScreen text="جاري تحديد نوع الحساب..." />;
}
import InstallPWA from "./components/ui/InstallPWA";
export default function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <Router />
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3500,
            style: {
              fontFamily: "'Segoe UI', system-ui, sans-serif",
              direction: "rtl",
              borderRadius: 12,
              fontWeight: 600,
              fontSize: 14,
              boxShadow: "0 8px 24px rgba(0,0,0,.15)",
            },
          }}
        />
        <InstallPWA />
      </SettingsProvider>
    </AuthProvider>
  );
}
